import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import '@foundit/footer/dist/FooterWeb.css';
import '@foundit/header/dist/HeaderWeb.css';
import HeaderWeb from '@foundit/header/dist/HeaderWeb';
import { FooterWeb } from '@foundit/footer/dist/FooterWeb';
import type { HeaderWebRef } from '@foundit/header/dist/HeaderWeb';
import { MIDDLEWARE } from './constants/api';

console.log('process.env.REACT_APP_CLEVERTAP', process.env.REACT_APP_CLEVERTAP);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


const RootComponent = () => {
  const headerRef = useRef<HeaderWebRef>(null);
useEffect(()=>{window.__globalHeaderRef__ = headerRef;},[])
  return (
    <Provider store={store}>
      <HeaderWeb ref={headerRef} middleware={MIDDLEWARE} page_name="Dashboard page" />
      <div style={{ marginBottom: 60,position:"relative",top:"54px" }}>
        <App />
      </div>
      <div style={{ position: 'fixed', bottom: 0, width: '100%' }}>
        <FooterWeb />
      </div>
    </Provider>
  );
};

root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);

reportWebVitals();
